import '@/scss/style.scss';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//
// All third-party, non-Vue.js libraries should be loaded here
//

import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

//
// Setup Vue.js
//

import { vOnClickOutside } from '@vueuse/components';
import { SwiperSlide as CarouselSlide } from 'swiper/vue';
import { createApp } from 'vue';
import { apolloProvider } from './config/apollo.js';

//
// Components
//

import VueEasyLightbox from 'vue-easy-lightbox';
import AccordionItem from './components/AccordionItem.vue';
import AsyncForm from './components/AsyncForm.vue';
import CardsGallery from './components/CardsGallery.vue';
import Carousel from './components/Carousel.vue';
import Checkout from './components/checkout/Checkout.vue';
import CollapseTransition from './components/CollapseTransition.vue';
import Field from './components/Field.vue';
import Gallery from './components/Gallery.vue';
import LabeledDropdown from './components/LabeledDropdown.vue';
import LabeledInput from './components/LabeledInput.vue';
import Navigation from './components/Navigation.vue';
import Parallax from './components/Parallax.vue';
import ParallaxGroup from './components/ParallaxGroup.vue';
import PostForm from './components/PostForm.vue';
import Product from './components/Product.vue';
import Quiz from './components/quiz/Quiz.vue';
import QuizStep from './components/quiz/QuizStep.vue';
import Rot13Email from './components/Rot13Email.vue';
import Shop from './components/Shop.vue';
import ShopPrice from './components/ShopPrice.vue';
import { store } from './store/index.js';

const app = createApp({
    delimiters: ['${', '}'],
    components: {
        Field,
        LabeledDropdown,
        LabeledInput,
        Navigation,
        Rot13Email,
        AccordionItem,
        AsyncForm,
        CardsGallery,
        Checkout,
        Gallery,
        PostForm,
        ParallaxGroup,
        Parallax,
        Carousel,
        CarouselSlide,
        CollapseTransition,
        VueEasyLightbox,

        // Shop components
        Shop,
        ShopPrice,
        Product,

        // Quiz components
        Quiz,
        QuizStep,
    },

    directives: {
        clickOutside: vOnClickOutside,
    },

    created() {
        this.$store.dispatch('cart/loadCart');
        this.$store.dispatch('wishlist/loadWishlist');
    },
});

app.use(store);

app.use(apolloProvider);

app.mount('#app');

// Remove our preload class from the body, preventing early CSS transitions
document.addEventListener('DOMContentLoaded', () => {
    document.getElementsByTagName('body')[0].classList.remove('preload');
});
